"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const AutoCompleteItem_1 = __importDefault(require("./AutoCompleteItem"));
const StyledAutoComplete_1 = require("./styled/StyledAutoComplete");
const inputKeyDownHandler_1 = require("../../handler/autoComplete/desktop/Common/inputKeyDownHandler");
const indexImgUrl_1 = require("../../resource/indexImgUrl");
const VerticalFocus_1 = __importDefault(require("./common/VerticalFocus"));
const AutoComplete = ({ autoValue, inputValue, onAutoCompClick, onRecentSearch, onAutoCompFocus, }) => {
    return ((0, jsx_runtime_1.jsx)(AutoComplete.List, { autoValue: autoValue, inputValue: inputValue, onAutoCompClick: onAutoCompClick, onRecentSearch: onRecentSearch, onAutoCompFocus: onAutoCompFocus }));
};
const List = react_1.default.memo(({ autoValue, inputValue, onAutoCompClick, onRecentSearch, onAutoCompFocus }) => {
    const targetStringList = (0, react_1.useMemo)(() => inputValue.split(" "), [inputValue]);
    const needBorder = Array.isArray(autoValue.keyword) &&
        autoValue.keyword.length > 0 &&
        Array.isArray(autoValue.rest) &&
        autoValue.rest.length > 0;
    const isAlone = !autoValue ||
        (!autoValue.keyword && !autoValue.rest) ||
        (Array.isArray(autoValue.keyword) &&
            autoValue.keyword.length === 0 &&
            Array.isArray(autoValue.rest) &&
            autoValue.rest.length === 0);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [autoValue &&
                autoValue.keyword &&
                autoValue.keyword.map((item, idx) => ((0, jsx_runtime_1.jsx)(AutoCompleteItem_1.default, { isKeyword: true, idx: idx, main_name: item?.main_name || "", sigungu: item?.sigungu || "", isLastKeyword: idx === (autoValue.keyword?.length || 0) - 1 && needBorder, targetStringList: targetStringList, onAutoCompClick: onAutoCompClick, onKeyDown: inputKeyDownHandler_1.onAutoCompKeyDown }, `keyword-${item?.main_name ?? ""}-${idx}`))), autoValue &&
                autoValue.rest &&
                autoValue.rest.map((item, idx) => {
                    if (item && item.main_name && item.addr && item.rest_id) {
                        return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, jsx_runtime_1.jsx)(AutoCompleteItem_1.default, { idx: idx + (autoValue.keyword?.length || 0), main_name: item.main_name, addr: item.addr, rest_id: item.rest_id, branch: item.branch, distance: item.distance, main_food: item.main_food, targetStringList: targetStringList, onAutoCompClick: onAutoCompClick, onKeyDown: inputKeyDownHandler_1.onAutoCompKeyDown }) }, `rest-${item.main_name}-${item.rest_id}-${idx}`));
                    }
                    return null;
                }), isAlone ? (onRecentSearch && ((0, jsx_runtime_1.jsx)(AutoComplete.Alone, { inputValue: inputValue, autoValue: autoValue, onRecentSearch: onRecentSearch, onKeyDown: inputKeyDownHandler_1.onAutoCompKeyDown }))) : ((0, jsx_runtime_1.jsx)(Spacer, {}))] }));
});
const Spacer = react_1.default.memo(() => {
    return (0, jsx_runtime_1.jsx)(StyledAutoComplete_1.AutoCompleteSpacerDiv, {});
});
const Alone = ({ inputValue, autoValue, onRecentSearch, onKeyDown, }) => {
    return ((0, jsx_runtime_1.jsx)(StyledAutoComplete_1.AutoCompleteAloneDiv, { className: "Auto__Complete__Wrap", children: autoValue ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: Array.isArray(autoValue.rest) &&
                autoValue.rest?.length === 0 &&
                Array.isArray(autoValue.keyword) &&
                autoValue.keyword?.length === 0 && ((0, jsx_runtime_1.jsxs)("button", { className: "Auto__Alone__Button", tabIndex: 0, onClick: () => {
                    onRecentSearch({
                        type: "query",
                        content: inputValue,
                        query: inputValue,
                    });
                }, onKeyDown: onKeyDown, children: [(0, jsx_runtime_1.jsx)(VerticalFocus_1.default, { height: "41px" }), (0, jsx_runtime_1.jsx)("img", { src: indexImgUrl_1.desktop_search_item_img, className: "Auto__Alone__Button__Img", alt: `'${inputValue}'로 검색하기 아이콘` }), (0, jsx_runtime_1.jsxs)("span", { className: "Auto__Alone__Content", children: ["'", inputValue, "'\u00A0", (0, jsx_runtime_1.jsx)("span", { className: "Auto__Alone__GuideText", children: "\uAC80\uC0C9" })] })] })) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) }));
};
AutoComplete.List = List;
AutoComplete.Alone = Alone;
exports.default = AutoComplete;
